exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".link-external{position:relative;box-sizing:border-box;display:inline-block;vertical-align:top;padding-left:50px;line-height:40px;text-decoration:none;height:40px;width:auto;max-width:1000px;font-size:20px;color:#7f8c8c;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.link-external:before{content:\"\";background:url(" + require("./link-external-green.png") + ") no-repeat 0 0;position:absolute;left:0;top:0;height:40px;width:40px}.link-external:hover{color:#e2534b}.link-external:hover:before{content:\"\";background:url(" + require("./link-external-red.png") + ") no-repeat 0 0}.link-external.empty{padding-left:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ddca3ef","scoped":false,"hasInlineConfig":true}!./src/components/link-external/link-external.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-7ddca3ef","scoped":false,"hasInlineConfig":true}!./src/components/link-external/link-external.css
// module chunks = index